var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"AverageAgingLineChart",staticStyle:{"height":"400px"}}),_vm._v(" "),_c('div',{staticStyle:{"height":"200px","overflow-y":"scroll"}},[_c('div',{ref:"legend"})])])}
var staticRenderFns = []

export { render, staticRenderFns }